import React from 'react';
import MUIDataTable from 'mui-datatables';
import { useVipContactList } from '../../../../libs/hooks';

const options = {
  filter: true,
  filterType: 'dropdown',
  responsive: 'vertical',
  search: true,
  rowsPerPage: 10,
  selectableRowsOnClick: false,
  selectableRowsHideCheckboxes: true
};

const VipTable = () => {
  const { headers, data } = useVipContactList();

  const deleteRowData = e => {
    console.log('onclick');
  };

  return (
    <MUIDataTable
      data={data}
      columns={headers}
      options={options}
      loading={true}
      onRowClick={deleteRowData}
    />
  );
};

export default VipTable;
